import React from 'react';
import type { FC } from 'react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
import styled from 'styled-components';
import { Link } from '@helpcenter/analytics-components/src/link';
import * as mixins from '@helpcenter/styles/src/mixins';
import { FormattedMessage } from 'react-intl-next';
import { di } from 'react-magnetic-di';
import { graphql, useFragment } from 'react-relay';
import messages from 'view/help-center/recent-forms/recent-forms-list-item/messages';
import { useIsPageInEditMode } from 'view/layout-next/controllers';
import { AnalyticsContext } from '@atlaskit/analytics-next';
import { token } from '@atlaskit/tokens';
import type { recentFormsListItem_on_RequestForm$key as RequestForm } from './__generated__/recentFormsListItem_on_RequestForm.graphql';

export const RecentFormsListItem: FC<{
    requestForm: RequestForm;
    isEmbeddedRoute?: boolean;
}> = ({ requestForm, isEmbeddedRoute }) => {
    di(useIsPageInEditMode);
    const { portalName, descriptionHtml, portalId, id, name } = useFragment<RequestForm>(
        graphql`
            fragment recentFormsListItem_on_RequestForm on HelpLayoutRequestForm {
                descriptionHtml
                portalName
                id
                portalId
                name
            }
        `,
        requestForm
    );
    const [isPageInEditMode] = useIsPageInEditMode();
    return (
        <AnalyticsContext data={{ attributes: { id } }}>
            {isPageInEditMode || !portalId ? (
                <Title>
                    <FormattedMessage {...messages.linkText} values={{ portalName, formName: name }} />
                </Title>
            ) : (
                <LinkContainer>
                    <FormLink
                        to={`/portal/${portalId}/create/${id}`}
                        actionSubjectId="suggestionRequestType"
                        target={isEmbeddedRoute ? '_blank' : undefined}
                    >
                        <FormattedMessage {...messages.linkText} values={{ portalName, formName: name }} />
                    </FormLink>
                </LinkContainer>
            )}
            {/* Safe to use dangerouslySetInnerHTML as the HTML is sanitised by Jira */}
            {descriptionHtml && <Description dangerouslySetInnerHTML={{ __html: descriptionHtml }} />}
        </AnalyticsContext>
    );
};

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const FormLink = styled(Link)`
    color: ${(props) => token('color.link', props.theme.color)};
`;

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const Title = styled.div`
    color: ${(props) => token('color.link', props.theme.color)};
`;

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const Description = styled.div`
    margin-top: ${token('space.050', '4px')};
    padding-left: ${token('space.025', '2px')};
    & p {
        ${mixins.clamp};
    }
`;

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const LinkContainer = styled.div`
    padding-left: ${token('space.025', '2px')};
`;
